/** CRIANDO UMA CLASSE  */
export class Task {

  /** CONSTRUTOR DA CLASSE JÁ COM OS PARAMETROS DA CLASS*/
  constructor(
      public id: number, 
      public title: string, 
      public description?: string, //QUANDO TEM ESSA ? - É PORQUE ELE NÃO É OBRIGATÓRIO
      public done?: boolean, 
      public deadline?: string
    ){}
}



// WEBPACK FOOTER //
// C:/xampp2/htdocs/angular-front/src/app/tasks/shared/task.model.ts